// File: frontend/src/components/ResetPasswordModal.js
// Version: 2.0 (UI Theme Match)
// Date: 2025-12-13 10:30 EST
// Description: Modal component for administrative password reset.
// Fixes: 
// - Replaced Tailwind classes with project-native CSS classes (UserManagement.css).
// - Added FiX icon for close button consistency.
// - Styled to match 'Add Employee' modal exactly.

import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FiX } from 'react-icons/fi'; // Импорт иконки закрытия
import apiService from '../services/apiService'; 

const ResetPasswordModal = ({ user, onClose }) => {
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (newPassword.length < 8) {
            toast.error("Password must be at least 8 characters");
            return;
        }

        setLoading(true);
        try {
            await apiService.adminResetPassword(user.id, newPassword);
            toast.success(`Password for ${user.first_name} updated successfully!`);
            onClose();
        } catch (error) {
            console.error("Password reset error:", error);
            toast.error(error.message || "Failed to reset password");
        } finally {
            setLoading(false);
        }
    };

    return (
        // Используем класс modal-overlay для затемнения фона
        <div className="modal-overlay" onClick={onClose}>
            {/* Используем класс modal-content для белой карточки */}
            <div 
                className="modal-content" 
                onClick={(e) => e.stopPropagation()} 
                style={{ maxWidth: '400px' }} // Чуть уже, чем форма сотрудника
            >
                {/* Кнопка закрытия (крестик) */}
                <button onClick={onClose} className="modal-close-button">
                    <FiX />
                </button>

                {/* Заголовок */}
                <h2
                    className="text-foreground"
                    style={{
                        fontSize: '1.5rem',
                        fontWeight: '700',
                        marginBottom: '1.5rem',
                        marginTop: 0
                    }}
                >
                    Reset Password
                </h2>

                {/* Блок информации о пользователе (стилизован под инфо-панель) */}
                <div
                    className="bg-popover border-border text-muted-foreground"
                    style={{
                        marginBottom: '1.5rem',
                        padding: '1rem',
                        borderRadius: '8px',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        fontSize: '0.9rem'
                    }}
                >
                    <div style={{ marginBottom: '4px' }}>
                        User: <strong className="text-foreground">{user.first_name} {user.last_name}</strong>
                    </div>
                    <div>Email: {user.email}</div>
                </div>

                {/* Форма */}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="new-password">New Password *</label>
                        <input
                            id="new-password"
                            type="password" 
                            className="form-input" // Ваш родной класс для инпутов
                            placeholder="Enter new strong password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            disabled={loading}
                            autoFocus
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="modal-actions">
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn btn-secondary bg-secondary text-secondary-foreground hover:bg-muted"
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn btn-primary bg-primary text-primary-foreground hover:bg-primary/90"
                            style={{ border: 'none' }}
                        >
                            {loading ? 'Saving...' : 'Save Password'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ResetPasswordModal;